// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__8dy8t","Tab":"Tabs_Tab__j_089","Selected":"Tabs_Selected__q317T"};